<template>
  <div>
    <div class="body container">
      <!--导航-->
      <div class="nav clearfix">
        <a
          :class="{'active':column.id == columnid}"
          href="#"
          v-for="column in brotherColumnData"
          :key="column.id"
          @click="changeColumn(column.mode,column.id,column.web_level,column.fix_column_name)"
        >{{column.title}}</a>
      </div>

      <!--学校简介-->
      <div class="content introBox">
        <div class="intro">
          <div
            style="color:#444e59;text-align:center;font-size: 24px;font-weight:bold;margin-bottom: 50px"
          >{{articleData.title}}</div>
          <span
            class="contentText"
            style="color:#6e7180;word-wrap: break-word;"
            v-html="articleData.content"
          ></span>
          <div class="noData" v-if="nodata" style="margin-top:70px;">
            <img src="../../assets/img/no_announcement.png" />
            <p>暂无公告，去别的地方看看吧~</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import globalApi from "@/common/globalApi.js";
export default {
  name: "home",
  data() {
    return {
      columnid: "",
      weblevel: "",
      mode: "",
      brotherColumnData: [],
      articleData: [],
      nodata: false,
      // columnTitle: ""
    };
  },

  components: {},

  computed: {
     globalVaranthasInited(){
         return globalApi.gWebsiteSessionInfo.hasInited;
     }
  },
  watch: {
    $route() {
      //监控$route
      this.columnid = this.$route.query.id;
      this.weblevel = this.$route.query.web_level;
      this.mode = this.$route.query.mode;
      this.getArticleData();
      this.getBrotherColumns();
      // this.getColumnTitle();
    },
    globalVaranthasInited: function(){        
        
        this.init();
      },
  },

  created() {
    this.columnid = this.$route.query.id;
    this.weblevel = this.$route.query.web_level;
    this.mode = this.$route.query.mode;

    // this.getColumnTitle();
  },
  methods: {
    init(){
         this.columnid = this.$route.query.id;
        this.weblevel = this.$route.query.web_level;
        this.mode = this.$route.query.mode;
        this.getArticleData();
        this.getBrotherColumns();
      },
    changeColumn(mode, id, web_level, address) {
      if (mode == 1) {
        address = "Article";
      } else if (mode == 2) {
        address = "ArticleList";
      } else if (mode == 3) {
        address = "VideoList";
      }
      this.$router.push(
        String(
          address +
            "?mode=" +
            mode +
            "&id=" +
            id +
            "&web_level=" +
            web_level +
            "&schoolid=" +
            this.$route.query.schoolid
        )
      );
    },
    async getBrotherColumns() {
      let data = {
        s: "WebSchoolSpace.Column.GetBrotherColumn",
        columnid: this.columnid,
        weblevel: this.weblevel,
        incdisabled: 1
      };

      let res = await globalApi.post( data);
      this.brotherColumnData = res.data.data;
    },
    async getArticleData() {
      let data = {
        s: "WebSchoolSpace.ColumnContent.GetArticle",
        weblevel: this.weblevel,
        columnid: this.columnid
      };

      let res = await globalApi.post( data);

      if (res.data.ret == 200 && res.data.data.result == 1) {
        this.articleData = res.data.data.article_info;
        this.nodata = this.articleData.content ? false : true;
      }
    },
    // async getColumnTitle() {
    //   let data = {
    //     s: "WebSchoolSpace.Column.GetArticleTitle",
    //     weblevel: this.weblevel,
    //     columnid: this.columnid
    //   };

    //   let res = await globalApi.post( data);

    //   if (res.data.ret == 200) {
    //     this.columnTitle = res.data.data;
    //   }
    //   document.title = "学校空间 - "+this.columnTitle;
    // }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/index_body.scss";
.intro {
  .contentText {
    white-space: pre-wrap;
    strong {
      font-weight: bold;
      em {
        font-style: italic;
        font-weight: bold;
      }
    }
    em {
      font-style: italic;
      strong {
        font-weight: bold;
        font-style: italic;
      }
    }
  }
}
</style>
<style scoped>
.el-tabs__nav-scroll {
  width: 1200px;
  margin: 0 auto;
}
.el-tabs__content {
  display: none;
}
</style>
<style lang="scss" >
.contentText{
img{
  max-width: 1000px;
  max-height: 1000px;
}
}
</style>
